<template>
  <div v-if="isOpen" class="position-absolute" style="z-index: 3; width: 250px">
    <div class="row mx-auto text-center my-2 p-3 bg-white shadow">
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(1)"
        >
          1
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(2)"
        >
          2
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(3)"
        >
          3
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(4)"
        >
          4
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(5)"
        >
          5
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(6)"
        >
          6
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(7)"
        >
          7
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(8)"
        >
          8
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(9)"
        >
          9
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount(0)"
        >
          0
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount('dot')"
        >
          .
        </button>
      </div>
      <div class="col-4 bg-white content-bank px-0 py-1">
        <button
          type="button"
          class="bg-light btn-outline-secondary btn-input-keyboard"
          @click="setAmount('bsp')"
        >
          <i class="fas fa-backspace fs-6"></i>
        </button>
      </div>
      <div class="col-12 mt-2">
        <button type="button" class="btn btn-primary w-100" @click="close()">
          ตกลง
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputNumberKeyBoard",
  data() {
    return {
      isOpen: false,
      amount: 0,
    };
  },
  mounted() {},
  methods: {
    setAmount(keyInput) {
      if (keyInput != "bsp" && keyInput != "dot") {
        this.amount += "" + keyInput;
        this.amount = parseInt(this.amount);
        this.setProductAmount(this.amount);
      } else {
        if (keyInput == "bsp") {
          this.amount = String(this.amount).substring(
            0,
            [String(this.amount).length - 1],
            1
          );
          this.setProductAmount(this.amount == "" ? 0 : this.amount);
        } else {
          if (this.amount == "" || this.amount == 0) {
            this.setProductAmount(0);
          }
        }
      }
    },
    getProductAmount() {
      this.amount = this.$parent.getInputValue();
    },
    setProductAmount(amount) {
      this.$emit("setAmount", amount);
    },
    getIsOpen() {
      return this.isOpen;
    },
    setIsOpen(isOpen) {
      this.isOpen = isOpen;
    },
    close() {
      this.isOpen = false;
      this.$emit("close", true);
    },
  },
};
</script>
<style>
.btn-input-keyboard {
  width: 50px;
  height: 50px;
  padding: 10px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 50%;
  border: 1px solid gray;
  cursor: pointer;
}
</style>
